<template>
  <div
    v-if="props.settings.gallery.header.html"
    v-html="props.settings.gallery.header.html"
  ></div>
  <div
    ref="widgetMarketplaceReviews"
    class="frisbuy-marketplace-reviews"
    :class="{ 'frisbuy-marketplace-reviews--fully': props.isFullyWidget }"
  >
    <div
      v-if="props.productRating"
      class="frisbuy-marketplace-reviews__product-raiting"
    >
      <div class="frisbuy-product-rating">
        <div class="frisbuy-product-rating__wrapper">
          <div class="frisbuy-product-rating__info">
            <div
              v-if="props.productRating?.avgRating"
              class="frisbuy-product-rating__stars"
            >
              <span>
                {{ props.productRating.avgRating.toFixed(1) }}
              </span>
            </div>

            <div class="frisbuy-product-rating__counts">
              {{ props.productRating.reviewsCount }}
              {{ getPluralizatedRatingCount() }}
            </div>
          </div>

          <RatingBar
            :divisionByRating="divisionByRating"
            :isSoftStarIcon="isSoftStarIcon"
          />
        </div>

        <button
          class="frisbuy-image-upload-button"
          :class="{ 'frisbuy-image-upload-button--fully': isFullyWidget }"
          widget-iu-button="true"
          onclick="iuWidget.open()"
        >
          <span>Оставить отзыв</span>
        </button>
        <button
          v-if="!isFullyWidget"
          class="frisbuy-image-all-reviews-button"
          :disabled="props.isShowFullyWidgetLoading"
          :aria-busy="props.isShowFullyWidgetLoading ? 'true' : 'false'"
          @click="emit('showFullyWidget')"
        >
          <span
            v-if="props.isShowFullyWidgetLoading"
            class="frisbuy-image-all-reviews-button__loader"
            aria-hidden="true"
          ></span>
          <span> Все отзывы {{ props.productRating.allReviewsCount }} </span>
        </button>
      </div>
    </div>

    <div class="frisbuy-marketplace-reviews__reviews-wrapper">
      <!-- #region Customers Photos -->
      <div class="frisbuy-marketplace-reviews__customers-photos">
        <h3
          class="frisbuy-marketplace-reviews__customers-photos-title"
          :class="{
            'frisbuy-marketplace-reviews__customers-photos-title--mobile':
              props.isMobileScreenSize,
          }"
        >
          Отзывы и рейтинг
        </h3>

        <div
          class="frisbuy-marketplace-reviews__mobile-rating"
          :class="{
            'frisbuy-marketplace-reviews__mobile-rating--mobile':
              props.isMobileScreenSize,
          }"
        >
          <StarRounded width="32px" />

          <span class="frisbuy-product-rating__mobile-rating-text">
            {{ props.productRating?.avgRating.toFixed(1) }}
            <div class="frisbuy-product-rating__mobile-counts">
              &nbsp;/
              {{ props.productRating?.reviewsCount }}
              {{ getPluralizatedRatingCount() }}
            </div>
          </span>
        </div>

        <div
          v-if="
            props.isLoadingCustomersMedia || allCustomersMediaList.length > 0
          "
          class="frisbuy-marketplace-reviews__customers-photos-scroll-container"
        >
          <div class="frisbuy-marketplace-reviews__customers-photos-list">
            <CustomersPhotosSkeleton
              v-if="props.isLoadingCustomersMedia"
              :isMobile="Boolean(props.isMobileScreenSize)"
              :itemsCount="props.isMobileScreenSize ? 4 : 6"
            />
            <MediaList
              v-else-if="allCustomersMediaList.length > 0"
              :mediaWidth="
                props.isMobileScreenSize
                  ? `calc(25% - ${(3 * 8) / 4}px)`
                  : '80px'
              "
              :mediaList="allCustomersMediaList"
              :totalMediaCount="customersMediaTotalCount ?? undefined"
              :maxMediaItems="isMobileScreenSize ? 4 : 6"
              isShowCountHover
              @selectMedia="
                (media: imageWithPostId) =>
                  emit(
                    'selectPost',
                    media.postId,
                    media,
                    undefined,
                    getMediaIndexInPost(media)
                  )
              "
            />
          </div>
        </div>
      </div>
      <!-- #endregion -->
      <div
        v-if="isHasSummary"
        class="frisbuy-marketplace-reviews__summary-section"
      >
        <div class="frisbuy-marketplace-reviews__summary-description">
          <span class="frisbuy-marketplace-reviews__summary-title">
            Что говорят люди
          </span>
          <span class="frisbuy-marketplace-reviews__summary-subtitle">
            собирательный отзыв на основе пользовательских мнений
          </span>
        </div>
        <span
          class="frisbuy-marketplace-reviews__summary-text"
          v-html="props.productRating?.summary?.text || ''"
        >
        </span>
      </div>
      <!-- #region Customers Photos -->

      <!-- #region Customers Reviews -->
      <div class="frisbuy-marketplace-reviews__customers-reviews">
        <div
          v-if="props.isFullyWidget"
          class="frisbuy-marketplace-reviews__filters"
          :class="{
            'frisbuy-marketplace-reviews__filters--no-media-loading':
              isNoMediaLoadingState,
          }"
        >
          <div
            class="frisbuy-marketplace-reviews__filter frisbuy-marketplace-reviews--min-full"
            v-if="props.extraData?.currentVariantPostsCount"
          >
            <FrSegmented
              v-model="filterSegment"
              class="frisbuy-marketplace-reviews__segmented-list"
              :disabled="isFiltersDisabled"
              :options="[
                { label: 'Все отзывы', value: 'false' },
                { label: `Этот вариант`, value: 'true' },
              ]"
              :defaultOption="{ label: 'Все отзывы', value: 'false' }"
            />
          </div>

          <!-- <div class="frisbuy-marketplace-reviews__filter">
            <label>Показать с оценкой</label>

            <FrSelect
              v-model="filterRating"
              :options="[
                { value: undefined, text: 'Все' },
                { value: 5, text: '5 звезд' },
                { value: 4, text: '4 звезды' },
                { value: 3, text: '3 звезды' },
                { value: 2, text: '2 звезды' },
                { value: 1, text: '1 звезда' },
              ]"
              :defaultOption="{ value: 0, text: 'Все' }"
            />
          </div> -->

          <div
            v-if="isMediaFilterVisible"
            class="frisbuy-marketplace-reviews__filter frisbuy-marketplace-reviews__filter--auto"
          >
            <button
              type="button"
              class="frisbuy-marketplace-reviews__media-filter-button"
              :class="{
                'frisbuy-marketplace-reviews__media-filter-button--active':
                  isMediaFilterEnabled,
              }"
              :disabled="isFiltersDisabled"
              @click="toggleMediaFilter"
            >
              С фото/видео
            </button>
          </div>

          <div
            class="frisbuy-marketplace-reviews__filter frisbuy-marketplace-reviews__filter--auto"
          >
            <FrSelect
              v-model="filterSort"
              :disabled="isFiltersDisabled"
              :options="[
                {
                  value: 'provider_created',
                  sort: 'desc',
                  text: 'Сначала новые',
                },
                {
                  value: 'rating',
                  sort: 'desc',
                  text: 'Сначала с высокой оценкой',
                },
                {
                  value: 'rating',
                  sort: 'asc',
                  text: 'Сначала с низкой оценкой',
                },
              ]"
              :defaultOption="{
                value: 'provider_created',
                sort: 'desc',
                text: 'Сначала новые',
              }"
            />
          </div>
        </div>

        <ul v-if="postList.length" class="frisbuy-marketplace-reviews__list">
          <template
            v-for="(post, postIndex) in showedPostList"
            :key="postIndex"
          >
            <li
              v-if="post"
              class="frisbuy-marketplace-reviews__list-item"
              @click="
                () =>
                  emit(
                    'selectPost',
                    post.instagramPost.frisbuyId,
                    undefined,
                    post
                  )
              "
            >
              <CustomerReview
                :customerName="
                  post.instagramPost.authorUser.fio ||
                  `@${post.instagramPost.authorUser.username}`
                "
                :reviewDate="postExtractor.getParsedReviewDate(post)"
                :rating="post.frisbuyPost.rating"
                :mediaList="post.media"
                :isShowMedia="post.instagramPost.hasMedia"
                :negativeComment="post.frisbuyPost.negativeComment"
                :positiveComment="post.frisbuyPost.positiveComment"
                :text="post.frisbuyPost.text"
                :isSoftStarIcon="isSoftStarIcon"
                @selectReview="
                  () =>
                    emit(
                      'selectPost',
                      post.instagramPost.frisbuyId,
                      undefined,
                      post
                    )
                "
                @selectMedia="
                  (media: imageWithPostId) =>
                    emit('selectPost', post.instagramPost.frisbuyId, media, post)
                "
              />
            </li>
          </template>
        </ul>
        <span v-else class="frisbuy-marketplace-reviews-not-found-text">
          Отзывы по выбранным фильтрам не найдены
        </span>
      </div>
      <!-- #endregion Customers Reviews -->
      <!-- #region Pagination -->
      <div
        v-if="
          countOfPages > 0 &&
          isFullyWidget &&
          postList.length > 0 &&
          !isLastPage
        "
        class="frisbuy-marketplace-reviews__pagination"
      >
        <LoadMoreButton
          :countOfPages="countOfPages"
          :selectedPage="selectedPage"
          :isLoadPosts="isLoadPosts"
          @selectPage="(page) => selectPage(page)"
        />
      </div>
      <div
        v-if="
          countOfPages > 0 &&
          isFullyWidget &&
          isMobileScreenSize &&
          postList.length > 0 &&
          !isLastPage
        "
        ref="mobileLoadMoreSentinel"
        class="frisbuy-marketplace-reviews__mobile-loadmore-sentinel"
      ></div>
      <!-- #endregion Pagination -->
    </div>
    <button
      v-if="isFullyWidget"
      class="frisbuy-marketplace-reviews__mobile-iu"
      widget-iu-button="true"
      onclick="iuWidget.open()"
    >
      Оставить отзыв
    </button>
  </div>
</template>

<script setup lang="ts">
// Modules
import {
  computed,
  nextTick,
  onBeforeUnmount,
  ref,
  watch,
  onMounted,
  onBeforeMount,
} from "vue";
// Components
import CustomerReview from "./components/CustomerReview.vue";
import CustomersPhotosSkeleton from "./components/CustomersPhotosSkeleton.vue";
import LoadMoreButton from "./components/LoadMoreButton/LoadMoreButton.vue";
import MediaList from "./components/MediaList.vue";
import RatingBar from "./components/RatingBar/RatingBar.vue";
import FrSelect from "./components/FrSelect/FrSelect.vue";
import FrSegmented from "./components/FrSegmented/FrSegmented.vue";
// Services
import { getPostsInfo, TPostsFilterOptions } from "../../api/api";
// Icons
import StarRounded from "./Icons/StarRounded.vue";
// Types
import {
  imageWithPostId,
  IMarketplaceReviewsPost,
  productRating,
} from "./interfaces";
import { TRating } from "./interfaces";
// Hooks
import usePostExtractor from "./hooks/postExtractor";

const postExtractor = usePostExtractor();

const props = defineProps<{
  settings: { [key: string]: any };
  propPostList: Array<IMarketplaceReviewsPost>;
  lastPage: Boolean;
  propPostCount: number;
  allCustomersMediaList?: Array<imageWithPostId>;
  customersMediaTotalCount?: number | null;
  isLoadingCustomersMedia?: boolean;
  isShowFullyWidgetLoading?: boolean;
  productRating?: productRating;
  isFullyWidget?: boolean;
  isMobileScreenSize?: boolean;
  extraData: { currentVariantPostsCount?: number };
}>();
const emit = defineEmits([
  "selectPost",
  "sendAnaliticEvent",
  "showFullyWidget",
  "changeMediaSort",
  "mergeMediaFromPosts",
]);

const hadSeen = ref(false);
const inViewTimeout = ref<number | undefined>(undefined);
const had5SecInView = ref(false);

const postList = ref<IMarketplaceReviewsPost[]>(props.propPostList);

onBeforeMount(() => {
  updateCountOfPages();
});

const countOfPages = ref(0);
const isLastPageByRequest = ref(Boolean(props.lastPage));

const isLastPage = computed(() => {
  return isLastPageByRequest.value || selectedPage.value === countOfPages.value;
});

const showedPostList = computed(() => {
  if (props.isFullyWidget) {
    return postList.value;
  }

  return postList.value.slice(0, 3);
});

function selectPage(page: number) {
  selectedPage.value = page;

  emit(
    "sendAnaliticEvent",
    "NextPage",
    ++page,
    props.settings.analytics.sendNextPageToClient
  );

  updatePostList();
}

function updateCountOfPages() {
  countOfPages.value = Math.ceil(postCount.value / perPage);
}

// Product rating
const divisionByRating = computed<TRating[] | []>(() => {
  if (!props.productRating) {
    console.error("productRating not defined");

    return [];
  }

  const productRating: Array<TRating> = Object.values(
    props.productRating.divisionByRating
  ).map((value, index) => {
    return {
      label: String(index + 1),
      count: Number(value),
    };
  });

  return productRating.reverse();
});

const isSoftStarIcon = computed(() => {
  return props.settings.gallery.starIconType === "1";
});

const isHasSummary = computed(() => {
  if (!props.productRating) return false;

  return props.productRating.summary;
});

function isElementInView(element: any, isFull = false) {
  if (!element) return;

  const { top, bottom, height } = element.getBoundingClientRect();
  const { innerHeight: windowHeight } = window;

  if (isFull) {
    return (
      (height > windowHeight && bottom > 0 && bottom < windowHeight) ||
      (top > 0 && bottom < windowHeight)
    );
  } else {
    return top < windowHeight;
  }
}

function scrollHandler() {
  const InView5SecHandler = () => {
    had5SecInView.value = true;
    emit("sendAnaliticEvent", "Eyesight5Sec", window.location.href, true, true);
  };

  nextTick(() => {
    const firstItem = widgetMarketplaceReviews.value?.querySelector(
      ".frisbuy-marketplace-reviews__list-item"
    );
    if (
      !had5SecInView.value &&
      isElementInView(widgetMarketplaceReviews.value, true)
    ) {
      window.clearTimeout(inViewTimeout.value);

      inViewTimeout.value = setTimeout(InView5SecHandler, 5000);
    } else {
      window.clearTimeout(inViewTimeout.value);
    }

    if (
      !hadSeen.value &&
      isElementInView(firstItem || widgetMarketplaceReviews.value, true)
    ) {
      hadSeen.value = true;
      emit("sendAnaliticEvent", "Eyesight", window.location.href, true, true);
    }
  });
}

function getPluralizatedRatingCount() {
  if (!props.productRating) {
    return "";
  }

  const lastTwo = Math.abs(props.productRating.reviewsCount) % 100;
  const lastOne = Math.abs(props.productRating.reviewsCount) % 10;

  if (lastTwo >= 11 && lastTwo <= 14) {
    return "оценок";
  }

  if (lastOne === 1) {
    return "оценка";
  }

  if (lastOne >= 2 && lastOne <= 4) {
    return "оценки";
  }

  return "оценок";
}

function getMediaIndexInPost(media: imageWithPostId): number | undefined {
  const mediaOfPost = allCustomersMediaList.value.filter(
    (item) => item.postId === media.postId
  );
  if (!mediaOfPost.length) {
    return undefined;
  }

  const byRefIndex = mediaOfPost.findIndex((item) => item === media);
  if (byRefIndex >= 0) {
    return byRefIndex;
  }

  const byUrlIndex = mediaOfPost.findIndex((item) => {
    return (
      (item.thumbnailUrl && item.thumbnailUrl === media.thumbnailUrl) ||
      (item.imageHighResolutionUrl &&
        item.imageHighResolutionUrl === media.imageHighResolutionUrl) ||
      (item.imageUrl && item.imageUrl === media.imageUrl) ||
      (item.videoUrl && item.videoUrl === media.videoUrl)
    );
  });

  return byUrlIndex >= 0 ? byUrlIndex : undefined;
}

// Customers photo
const allCustomersMediaList = computed<Array<imageWithPostId>>(() => {
  return props.allCustomersMediaList ?? [];
});
const customersMediaTotalCount = computed<number | null>(() => {
  return props.customersMediaTotalCount ?? null;
});

const isNoMediaLoadingState = computed(() => {
  return Boolean(
    !props.isLoadingCustomersMedia && allCustomersMediaList.value.length === 0
  );
});

onMounted(() => {
  scrollHandler();
  window.addEventListener("scroll", scrollHandler);
  nextTick(() => {
    setupMobileLoadMoreObserver();
  });

  const { embedId, widgetStart } = props.settings;
  const entries = (performance && performance.getEntries()) || null;
  const times: any = {};

  if (entries) {
    if (widgetStart) {
      times.domInject = (performance.now() - widgetStart).toFixed(2);
    }

    entries.forEach((entry) => {
      if (entry.name.includes(embedId)) {
        times.queued = entry.startTime.toFixed(2);
        times.load = entry.duration.toFixed(2);
      } else if (
        entry.name.includes("www.frisbuy.ru") &&
        entry.name.includes("compiled")
      ) {
        times.bundle = entry.duration.toFixed(2);
      }
    });

    emit("sendAnaliticEvent", "TimeLoad", times, false, true);
  }

  emit("sendAnaliticEvent", "Load", window.location.href, true, true);

  if (props.settings.gallery.elasticFilter) {
    emit(
      "sendAnaliticEvent",
      "FilterElastic",
      window.location.href,
      true,
      true
    );
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", scrollHandler);
  mobileLoadMoreObserver?.disconnect();
  mobileLoadMoreObserver = null;
});

// Pagination and filters
const postCount = ref(props.propPostCount);
const perPage = postList.value.length;

const selectedPage = ref(1);

const widgetMarketplaceReviews = ref<HTMLElement | null>(null);
const mobileLoadMoreSentinel = ref<HTMLElement | null>(null);
let mobileLoadMoreObserver: IntersectionObserver | null = null;

const filterSegment = ref();
const filterSort = ref();
const filterRating = ref();
const mediaFilterValue = ref<"1" | undefined>(undefined);
const isMediaFilterEnabled = computed(() => mediaFilterValue.value === "1");
const isFiltersDisabled = computed(
  () => isLoadPosts.value || Boolean(props.isLoadingCustomersMedia)
);
const isMediaFilterVisible = computed(() => {
  if (props.isLoadingCustomersMedia) {
    return true;
  }

  if ((customersMediaTotalCount.value ?? 0) > 0) {
    return true;
  }

  return allCustomersMediaList.value.length > 0;
});

// NOTE: if need clear postLIst on filter update
watch(filterRating, () => {
  postList.value = [];
});

watch([filterSegment], async () => {
  selectedPage.value = 1;

  updatePostList(undefined, true);

  if (!props.isFullyWidget) {
    return;
  }

  const selectedOrderBy = filterSort.value?.value || "provider_created";
  const selectedSort = filterSort.value?.sort || "desc";
  const currentVariant = filterSegment.value?.value;

  emit(
    "changeMediaSort",
    selectedOrderBy,
    selectedSort,
    currentVariant === "true" ? "true" : undefined
  );
});

watch(
  [filterRating, filterSort],
  async (
    [newFilterRating, newFilterSort],
    [oldFilterRating, oldFilterSort]
  ) => {
    const isRatingChanged = newFilterRating?.value !== oldFilterRating?.value;
    const isSortChanged =
      newFilterSort?.value !== oldFilterSort?.value ||
      newFilterSort?.sort !== oldFilterSort?.sort;

    if (isRatingChanged || isSortChanged) {
      selectedPage.value = 1;
      updatePostList(undefined, true);
      return;
    }

    updatePostList();
  }
);

watch(mediaFilterValue, () => {
  selectedPage.value = 1;
  updatePostList(undefined, true);
});

watch(filterSort, (newFilterSort, oldFilterSort) => {
  if (!props.isFullyWidget || !newFilterSort) {
    return;
  }

  if (
    oldFilterSort &&
    newFilterSort.value === oldFilterSort.value &&
    newFilterSort.sort === oldFilterSort.sort
  ) {
    return;
  }

  emit(
    "changeMediaSort",
    newFilterSort.value,
    newFilterSort.sort || "desc",
    filterSegment.value?.value === "true" ? "true" : undefined
  );
});

const isLoadPosts = ref(false);

function toggleMediaFilter() {
  mediaFilterValue.value = mediaFilterValue.value === "1" ? undefined : "1";
}

function loadNextPageOnMobileScroll() {
  if (!props.isFullyWidget || !props.isMobileScreenSize) {
    return;
  }

  if (isLoadPosts.value || isLastPage.value) {
    return;
  }

  selectPage(selectedPage.value + 1);
}

function setupMobileLoadMoreObserver() {
  mobileLoadMoreObserver?.disconnect();
  mobileLoadMoreObserver = null;

  if (
    typeof window === "undefined" ||
    !("IntersectionObserver" in window) ||
    !props.isFullyWidget ||
    !props.isMobileScreenSize ||
    !mobileLoadMoreSentinel.value
  ) {
    return;
  }

  mobileLoadMoreObserver = new IntersectionObserver(
    (entries) => {
      if (!entries[0]?.isIntersecting) {
        return;
      }

      loadNextPageOnMobileScroll();
    },
    {
      root: null,
      threshold: 0.1,
    }
  );

  mobileLoadMoreObserver.observe(mobileLoadMoreSentinel.value);
}

async function updatePostList(
  page: number | undefined = undefined,
  isForceUpdate: boolean = false
) {
  const { embedId, skuId, groupId, srcDomain } = props.settings;
  const apiDefaults = { embedId, skuId, groupId, srcDomain };

  const pageForLoad = page || selectedPage.value;

  const selectedOrderBy = filterSort.value?.value;
  const selectedSort = filterSort.value?.sort;

  const filterOptions: TPostsFilterOptions = {
    page: pageForLoad,
    orgerBy: selectedOrderBy === "rating" ? "rating" : "provider_created",
    sort: selectedSort || "desc",
    ratingFilter: filterRating.value?.value,
    current_variant: filterSegment.value?.value,
    media_filter: mediaFilterValue.value,
  };

  isLoadPosts.value = true;

  try {
    // TODO: add request's error handler
    const postsInfo = await getPostsInfo(apiDefaults, filterOptions);
    const newPosts = postsInfo.posts;

    if (typeof postsInfo?.lastPage === "boolean") {
      isLastPageByRequest.value = postsInfo.lastPage;
    } else {
      isLastPageByRequest.value = selectedPage.value === countOfPages.value;
    }

    if (props.isFullyWidget) {
      emit("mergeMediaFromPosts", newPosts);
    }

    if (isForceUpdate) {
      postList.value = newPosts;
    }

    const pageIndex = perPage * (pageForLoad - 1);
    newPosts?.forEach((post: IMarketplaceReviewsPost, idx: number) => {
      postList.value[pageIndex + idx] = post;
    });

    postCount.value = postsInfo.postCount;
  } finally {
    isLoadPosts.value = false;
  }
}

watch(
  [
    () => props.isMobileScreenSize,
    () => props.isFullyWidget,
    () => postList.value.length,
    () => isLastPage.value,
  ],
  async () => {
    await nextTick();
    setupMobileLoadMoreObserver();
  }
);
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap");

.frisbuy-marketplace-reviews {
  &,
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  --frisbuy-color-primary: #212121;
  --frisbuy-color-primary-2: #ebebeb;
  --frisbuy-color-primary-3: #999999;
  --frisbuy-color-primary-4: #e5e5e5;
  --frisbuy-color-primary-5: #666666;
  --frisbuy-color-primary-6: #f6f6f6;
  --frisbuy-color-primary-7: #00b9bf;
  --frisbuy-color-primary-8: #f2f2f2;
  --frisbuy-color-primary-9: #99cc33;
  --frisbuy-color-white: #ffffff;

  display: flex;
  flex-direction: row-reverse;
  gap: 40px;

  max-width: 100vw;

  h2 {
    font-size: 25px;
  }

  @media screen and (max-width: 1024px) {
    flex-direction: column-reverse;
  }
}

.frisbuy-marketplace-reviews--fully {
  .frisbuy-marketplace-reviews__product-raiting {
    align-self: flex-start;
    position: sticky;
    top: -56px;

    @media only screen and (max-width: 1024px) {
      position: static;
      top: auto;
    }
  }
}

.frisbuy-marketplace-reviews__reviews-wrapper {
  width: 100%;
}

.frisbuy-marketplace-reviews__product-raiting {
}

.frisbuy-product-rating {
  display: flex;
  position: relative;
  justify-content: space-between;
  flex-direction: column;

  margin-top: 128px;

  &,
  * {
    font-family: inherit;
  }

  .frisbuy-rating-bar {
    max-width: 200px;
  }

  .frisbuy-product-rating__info {
    align-items: start;
  }

  .frisbuy-product-rating__info {
    display: flex;
    flex-direction: column;

    .frisbuy-product-rating__stars {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;

      align-items: center;

      gap: 0 12px;

      span {
        font-size: 48px;
        font-weight: 400;
        line-height: 48px;

        color: #212121;
      }
    }

    .frisbuy-product-rating__counts {
      white-space: nowrap;
      margin-top: 4px;
      color: #212121;

      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }

  .frisbuy-product-rating__wrapper {
    display: flex;
    gap: 36px;

    @media screen and (max-width: 1024px) {
      display: none;
    }
  }

  @media only screen and (max-width: 1024px) {
    margin: 0;
  }
}

.frisbuy-marketplace-reviews__mobile-rating {
  display: none;
  align-items: center;
  gap: 8px;

  margin-bottom: 40px;

  color: var(--frisbuy-color-primary);

  &.frisbuy-marketplace-reviews__mobile-rating--mobile {
    margin-bottom: 40px;
  }

  .frisbuy-product-rating__mobile-rating-text {
    display: flex;
    align-items: baseline;

    font-size: 40px;
    line-height: 48px;
    font-weight: 400;
    max-height: 48px;
  }

  .frisbuy-product-rating__mobile-counts {
    font-size: 16px;
    line-height: 38px;
    font-weight: 400;
  }

  svg {
    fill: currentColor;
  }

  @media only screen and (max-width: 1024px) {
    display: flex;
  }
}

.frisbuy-image-upload-button {
  position: relative;

  width: 100%;
  height: 40px;

  margin-top: 24px;

  border: 1px solid var(--frisbuy-color-primary-5);
  border-radius: 80px;

  color: var(--frisbuy-color-primary);
  background-color: transparent;

  padding: 10px 0;

  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;

  &--fully {
    background-color: var(--frisbuy-color-primary-7);
    border-color: var(--frisbuy-color-primary-7);
    color: var(--frisbuy-color-white);
  }

  @media only screen and (max-width: 1024px) {
    margin: 0;
  }
}

.frisbuy-image-all-reviews-button {
  position: relative;

  width: 100%;
  height: 40px;

  margin-top: 12px;

  border: 0;
  background-color: var(--frisbuy-color-primary-7);
  border-radius: 80px;

  color: var(--frisbuy-color-white);

  padding: 10px 0;

  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:disabled {
    opacity: 0.75;
    cursor: default;
  }
}

.frisbuy-image-all-reviews-button__loader {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: rgba(255, 255, 255, 1);
  animation: frisbuy-button-spin 0.8s linear infinite;
  flex: 0 0 auto;
}

@keyframes frisbuy-button-spin {
  to {
    transform: rotate(360deg);
  }
}

.frisbuy-marketplace-reviews__customers-photos {
  position: relative;
  max-width: 100%;

  .frisbuy-marketplace-reviews__customers-photos-button {
    display: none;
    margin-top: 24px;
  }

  .frisbuy-marketplace-reviews__customers-photos-scroll-container {
    margin-right: 0;
    margin-left: 0;
    max-width: 100%;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    .frisbuy-marketplace-reviews__customers-photos-list {
      display: flex;
      position: relative;
      width: fit-content;
      gap: 5px;
      overflow-x: auto;
      width: 100%;
    }
  }
}

.frisbuy-marketplace-reviews__customers-photos-title {
  font-size: 48px;
  line-height: 64px;
  font-weight: 400;
  margin: 40px 0 24px;
  color: #212121;

  &.frisbuy-marketplace-reviews__customers-photos-title--mobile {
    margin: 0 0 40px;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    margin: 32px 0 40px;

    &.frisbuy-marketplace-reviews__customers-photos-title--mobile {
      margin: 32px 0 40px;
    }
  }
}

@media only screen and (max-width: 1024px) {
  .frisbuy-marketplace-reviews--fully .frisbuy-marketplace-reviews__list-item {
    margin-top: 40px !important;
  }

  .frisbuy-marketplace-reviews--fully
    .frisbuy-marketplace-reviews__mobile-rating.frisbuy-marketplace-reviews__mobile-rating--mobile {
    margin-bottom: 20px;
  }

  .frisbuy-marketplace-reviews--fully
    .frisbuy-marketplace-reviews__customers-photos-title.frisbuy-marketplace-reviews__customers-photos-title--mobile {
    margin: 0 0 20px;
  }
}

.frisbuy-marketplace-reviews__summary-section {
  display: flex;
  flex-direction: column;
  gap: 8px;

  margin: 14px 0 20px;
}

.frisbuy-marketplace-reviews__summary-description {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.frisbuy-marketplace-reviews__summary-title {
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  color: #303133;
}

.frisbuy-marketplace-reviews__summary-subtitle {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: #909399;
}

.frisbuy-marketplace-reviews__summary-text {
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: #303133;

  white-space: break-spaces;
}

.frisbuy-marketplace-reviews__customers-reviews {
  .frisbuy-marketplace-reviews__list {
    list-style-type: none;

    margin: 0;
    padding: 0;

    .frisbuy-marketplace-reviews__list-item {
      margin-top: 40px;

      @media only screen and (max-width: 1024px) {
        &:first-child {
          margin-top: 32px;
        }
      }
    }
  }

  .frisbuy-marketplace-reviews-not-found-text {
    display: block;

    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #606266;
    min-width: -moz-fit-content;
    min-width: fit-content;
    text-align: center;

    margin-top: 20px;
  }
}

/* Filters START */

.frisbuy-marketplace-reviews__filters {
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;

  gap: 8px;

  margin-top: 40px;

  &.frisbuy-marketplace-reviews__filters--no-media-loading {
    margin-top: 0;
  }

  .frisbuy-marketplace-reviews__filter {
    display: flex;
    position: relative;

    flex-direction: row;
    flex-wrap: nowrap;

    width: 100%;
    min-width: 265px;
    height: 40px;

    flex: 1 1 0px;
    gap: 0 12px;

    &.frisbuy-marketplace-reviews--min-full {
      width: 250px;
      min-width: 0;
      flex: 0 0 auto;
      max-width: 250px;

      @media only screen and (max-width: 1024px) {
        width: 228px;
        max-width: 228px;
      }
    }

    &.frisbuy-marketplace-reviews__filter--auto {
      width: fit-content;
      min-width: fit-content;
      flex: 0 0 auto;
    }
  }

  .frisbuy-marketplace-reviews__media-filter-button {
    width: fit-content;
    height: 100%;

    border: 1px solid rgba(229, 229, 229, 1);
    border-radius: 999px;
    background: #ffffff;

    padding: 12px 16px;

    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    color: rgba(33, 33, 33, 1);
    transition: border-color 0.3s ease, color 0.3s ease;

    cursor: pointer;

    &:hover:not(:disabled) {
      border-color: #00b9bf;
      color: #00b9bf;
    }
  }

  .frisbuy-marketplace-reviews__media-filter-button--active {
    border-color: #00b9bf;
    color: #00b9bf;
  }

  .frisbuy-marketplace-reviews__media-filter-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

/* Filters END */
</style>

<style lang="scss">
.frisbuy-marketplace-reviews__segmented-list {
  border-radius: 48px;
  background: var(--frisbuy-color-primary-8);
  border: none;

  color: var(--frisbuy-color-primary);
}

.frisbuy-marketplace-reviews__pagination {
  @media screen and (max-width: 1024px) {
    display: none;
  }
}

.frisbuy-marketplace-reviews__mobile-loadmore-sentinel {
  width: 100%;
  height: 1px;
}

.frisbuy-marketplace-reviews__mobile-iu {
  display: none;
  position: fixed;
  bottom: 16px;
  left: 16px;
  right: 16px;

  padding: 10px 0;
  height: 40px;

  border: 1px solid var(--frisbuy-color-primary-5);

  border-radius: 80px;
  background-color: transparent;

  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: var(--frisbuy-color-primary);

  cursor: pointer;

  &:hover {
    border: 1px solid var(--frisbuy-color-primary-7);
    color: var(--frisbuy-color-primary-7);
  }

  @media screen and (max-width: 1024px) {
    display: block;
  }
}
</style>
